import { CurrencyText } from "@/components/common/text";

// CurrencyText renders its empty-dash fallback without the caller's className, which breaks the
// vertical rhythm of the rate cards (labels/bars shift when a value is missing). This wrapper keeps
// the dash on the same typography as the value so both cards stay aligned with the design.
export const RateValueText = ({ num, className, round, emptyDash = false }) => {
    if (!num) return emptyDash ? <span className={className}> - </span> : null;
    return <CurrencyText num={num} round={round} className={className} />;
};
